var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDicountHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 14,
    viewBox: "0 0 43 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4781 13.8594C21.398 13.8594 21.3173 13.8432 21.2396 13.8079L1.31687 4.80095V13.2608C1.31687 13.5918 1.05354 13.8594 0.727769 13.8594C0.402588 13.8594 0.138672 13.5918 0.138672 13.2608V2.95862L21.7179 12.7138C22.0154 12.8484 22.1491 13.2022 22.0172 13.5038C21.9194 13.7271 21.7044 13.8594 21.4781 13.8594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4785 13.8594C21.2523 13.8594 21.0373 13.7271 20.9395 13.5038C20.8076 13.2022 20.9413 12.8484 21.2388 12.7138L42.8186 2.95862V13.2608C42.8186 13.5918 42.5547 13.8594 42.2295 13.8594C41.9037 13.8594 41.6404 13.5918 41.6404 13.2608V4.80095L21.7171 13.8079C21.6394 13.8432 21.5587 13.8594 21.4785 13.8594Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.478 13.8594C21.3325 13.8594 21.1864 13.8049 21.0727 13.6954L9.76023 2.78683V7.69732C9.76023 8.02832 9.4969 8.29587 9.17113 8.29587C8.84595 8.29587 8.58203 8.02832 8.58203 7.69732V-1.1138e-05L21.8833 12.8263C22.1195 13.0543 22.1289 13.4332 21.9056 13.6726C21.789 13.7971 21.6341 13.8594 21.478 13.8594Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4777 13.8594C21.3216 13.8594 21.1666 13.7971 21.05 13.6726C20.8267 13.4332 20.8362 13.0543 21.0724 12.8263L34.3742 -1.1138e-05V7.69732C34.3742 8.02832 34.1103 8.29587 33.7851 8.29587C33.4593 8.29587 33.196 8.02832 33.196 7.69732V2.78683L21.883 13.6954C21.7693 13.8049 21.6232 13.8594 21.4777 13.8594Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDicountHead);
export default __webpack_public_path__ + "static/media/dicount_head.e3764a77a19b5c6fd1ccf6785d66603f.svg";
export { ForwardRef as ReactComponent };